import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import * as g from 'src/app/globals';

@Injectable({
  providedIn: 'root',
})
export class CanActivateExternalPortal implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (g.getToken() === null || g.getToken() === '') {
      if (g.redirectToEmployeeLogin) {
        this.router.navigate(['/apps/authentication/login']);
      } else if (g.redirectToExternalLogin) {
        this.router.navigate(['/apps/authentication/external-login']);
      } else {
        this.router.navigate(['/apps/authentication/landing']);
      }

      return false;
    }

    if (window.location !== window.parent.location) {
      return true;
    }

    return this.authenticationService
      .isTokenValid()
      .then((r: { Success: boolean; Message: string; Area: number }) => {
        if (r.Success === false) {
          if (g.redirectToEmployeeLogin) {
            this.router.navigate(['/apps/authentication/login']);
          } else if (g.redirectToExternalLogin) {
            this.router.navigate(['/apps/authentication/external-login']);
          } else {
            this.router.navigate(['/apps/authentication/landing']);
          }
        } else if (r.Success && r.Area === 1) {
          this.router.navigate(['/apps/core/index']);
        }

        return r.Success && (r.Area === 2 || r.Area === 3);
      });
  }
}
